import dayjs from 'dayjs'
import { MessageMemo } from 'src/models/MessageMemo'
import useSWR from 'swr'
import { IterableElement } from 'type-fest'
import { ApiClient } from './client'
import { DELETE_COMPANY_MEMOS, POST_COMPANY_MEMOS } from './endpoints'
import {
  CreateMessageMemoRequest,
  DeleteMessageMemoRequest,
  MessageMemosResponse,
} from './types/messageMemo'

const messageMemoFetcher = async (url: string, _: any) => {
  if (!url) return []
  const res = await ApiClient.get<{ memos: MessageMemosResponse }>(url)
  return res.data?.memos ? res.data?.memos.map(toMessageMemo) : []
}

export const useMessageMemos = (url: string) => useSWR(url, messageMemoFetcher)

export const toMessageMemo = (
  memo: IterableElement<MessageMemosResponse>,
): MessageMemo => ({
  id: memo.id,
  roomId: memo.companyMessageRoomId,
  companyId: memo.companyId,
  content: memo.content,
  createdAt: dayjs(memo.createdAt),
})

export const createMessageMemo = async (
  companyMessageRoomId: number,
  content: string,
) => {
  const body: CreateMessageMemoRequest = {
    company_message_room_id: companyMessageRoomId,
    content: content,
  }
  return ApiClient.post(POST_COMPANY_MEMOS, body)
}

export const deleteMessageMemo = async (
  id: number,
  companyMessageRoomId: number,
) => {
  const body: DeleteMessageMemoRequest = {
    id: id,
    company_message_room_id: companyMessageRoomId,
  }
  return ApiClient.post(DELETE_COMPANY_MEMOS, body)
}
